export { default as AdapterNaturalIdentificationService } from "./AdapterNaturalIdentificationService"
export { default as AdapterIdentificationService } from "./AdapterIdentificationService"
